import FormCrudCRUDContext from "context/FormCrudContex";
import React, { useContext } from "react";

export const PDFRestOfTheWorldSalida = ({ values }) => {
  const { commercial_invoice, value_duta } = values;
  const { opcional } = useContext(FormCrudCRUDContext);

  return (
    <div className="row">
      <div className="col">
        <p>
          <strong>Factura Comercial: </strong> {commercial_invoice}
        </p>
      </div>

      <div className="col">
        {opcional && (
          <p>
            <strong>{opcional}: </strong> {value_duta}
          </p>
        )}
      </div>
    </div>
  );
};
